import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { toast } from "@krea/shared/design-system/utils/toast";

import { mutationKeyMap, queryKeyMap } from "@/features/query-client";

import { addInternalComment } from "../../api";
import type { IAddLenderInternalCommentInput } from "../../types/lender-application";

interface IMutationInput {
  lenderCompanyId: number;
  lenderApplicationId: number;
  data: IAddLenderInternalCommentInput;
}

type IMutationResult = Awaited<ReturnType<typeof addInternalComment>>;

export const useAddInternalCommentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<IMutationResult, AxiosError, IMutationInput>({
    mutationFn: async ({ data, lenderApplicationId, lenderCompanyId }) => {
      return await addInternalComment(
        lenderCompanyId,
        lenderApplicationId,
        data,
      );
    },
    mutationKey: mutationKeyMap.addInternalComment,
    onSuccess: (response, { lenderApplicationId }) => {
      const queryKey = queryKeyMap.getLenderApplication(lenderApplicationId);

      queryClient.setQueryData(queryKey, response);
    },
    onError: () => {
      toast.error("Failed posting internal comment");
    },
  });
};
